import type { ReviewOption } from "./LeafTabs.types";

export const byP = (a: ReviewOption, b: ReviewOption) =>
  (b.p ?? 0) - (a.p ?? 0);
